import { useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { ActionButton, FormDialog } from "../common";

export const WorkOrderDelete = ({ order, onDeleted }) => {
  const [open, setOpen] = useState(false), [busy, setBusy] = useState(false), [error, setError] = useState("");
  const remove = async () => {
    if (busy) return;
    setBusy(true); setError("");
    try {
      await api.delete(`/fleet/work-orders/${order.id}`, { params: { version: order.version || 0 } });
      setOpen(false); toast.success(`${order.wo_number} deleted`); onDeleted();
    } catch (e) { setError(errMsg(e)); } finally { setBusy(false); }
  };
  return <>
    <ActionButton testId={`wo-delete-${order.id}`} type="button" variant="danger" aria-label={`Delete ${order.wo_number}`} onClick={() => { setError(""); setOpen(true); }}><Trash2 size={15} /> Delete</ActionButton>
    <FormDialog open={open} onOpenChange={(value) => { if (!busy) setOpen(value); }} title={`Delete ${order.wo_number}?`} testId={`wo-delete-dialog-${order.id}`} className="w-[calc(100%_-_2rem)] max-w-lg">
      <p data-testid={`wo-delete-warning-${order.id}`} className="text-sm break-words">Permanently delete this work order, its labor/checklist history and attachment records? This cannot be undone.</p>
      <p data-testid={`wo-delete-stock-rule-${order.id}`} className="text-sm">Reserved parts will be released. Already consumed stock and asset statuses will not change. Completed orders must be reopened and timers stopped first.</p>
      {error && <p role="alert" data-testid={`wo-delete-error-${order.id}`} className="text-sm text-red-700 break-words">{error}</p>}
      <div className="flex flex-wrap justify-end gap-3"><ActionButton testId={`wo-delete-cancel-${order.id}`} type="button" variant="secondary" disabled={busy} onClick={() => setOpen(false)}>Keep Work Order</ActionButton><ActionButton testId={`wo-delete-confirm-${order.id}`} type="button" variant="danger" disabled={busy} onClick={remove}>{busy ? "Deleting…" : "Delete Permanently"}</ActionButton></div>
    </FormDialog>
  </>;
};
